import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isEqual } from 'lodash';

// parse URL param values from URL
const parseURLSearchParams = <ParamsT extends Record<string, unknown>>(
  search: string
): ParamsT => {
  const params = new URLSearchParams(search);

  const paramsObj: Record<string, unknown> = {};

  for (const [key, value] of params) {
    paramsObj[key] = value;
  }

  return paramsObj as ParamsT;
};

/** Gets url search params as an object */
export const useURLSearchParams = <ParamsT extends Record<string, any>>() => {
  const { search } = useLocation();

  const [params, setParams] = useState<Partial<ParamsT>>(
    parseURLSearchParams<ParamsT>(search)
  );

  useEffect(() => {
    const newParsedParams = parseURLSearchParams<ParamsT>(
      new URLSearchParams(search).toString()
    );

    if (isEqual(params, newParsedParams)) return;

    setParams(newParsedParams);
  }, [search]);

  return {
    /** Parsed URL params to an object */
    params,
  };
};
